import { FormHandle } from '@/hooks/use-form-handle.hook';
import { FC, useEffect } from 'react';
import InputControl from '@/components/form/input-control';
import { isWriteMode, ViewMode } from '@/lib/helpers';
import { Box } from '@mui/material';
import { PrivateModelModel } from '@/lib/models/private-model/private-model.model';

interface Props {
  formHandle: FormHandle<PrivateModelModel>;
  mode: ViewMode;
}

const AzureOpenAIPrivateModel: FC<Props> = ({ formHandle, mode }) => {
  const inWriteMode = isWriteMode(mode);
  const { setFieldValue } = formHandle;

  useEffect(() => {
    setFieldValue('provider', 'azure', false);
  }, [setFieldValue]);

  if (!inWriteMode) {
    return null;
  }

  const handleChange = (value: string) => {
    setFieldValue('modelId', value, false);
  };

  return (
    <Box>
      <InputControl
        name="config.deploymentId"
        label="Deployment ID"
        formHandle={formHandle}
        onChange={handleChange}
      />
    </Box>
  );
};

export default AzureOpenAIPrivateModel;
